import TablaConciliacion from "../../../TablaConciliacion";

function TablaPeajesNacionales() {
  return <TablaConciliacion nombreUseCase="PEAJESNACIONALES" titulo="PEAJES NACIONALES" />;
}

export default TablaPeajesNacionales;
